<template>
	<CRow>
		<CCol sm="12">
			<CButton @click="collapse=!collapse" color="primary" class="mb-2">
				فیلتر داده‌ها
			</CButton>
			<CCollapse :show="collapse" :duration="400">
				<CCard>
					<CCardHeader>
						<strong>گزینه‌های فیلتر</strong>
					</CCardHeader>
					<CCardBody>
						<CRow>
                            <CCol sm="3">
								<CInput v-model="form.number.val" size="sm" dir="ltr" disabled />
								<CButton @click="modal=true" size="sm" color="info" block>انتخاب شماره</CButton>
							</CCol>
                            <CCol sm="3">
								<CInput v-model="form.real_number.val" :description="form.real_number.inv" dir="ltr" label="شماره اصلی" />
							</CCol>
						</CRow>
						<br>
						<div class="form-group form-actions">
							<CButton @click="validator();filter=true;page=1;get()" class="ml" color="primary">فیلتر</CButton>
							<CButton @click="remove_filter" color="danger">حذف فیلتر</CButton>
						</div>
					</CCardBody>
				</CCard>
			</CCollapse>
		</CCol>
		<CCol col="12" xl="12">
			<CCard>
				<CCardHeader>
					<strong>DIDS</strong> 
					<div class="card-header-actions">
						تعداد: {{row_count}}
					</div>
				</CCardHeader>
				<CCardBody>
					<CCol sm="5">
						<CSelect v-model="limit" horizontal label="تعداد سطرها" :options="[
						{value: 10}, {value: 20}, {value: 50}, {value: 100}]" class="row-count"
						placeholder="تعداد سطرها" @change="limit=$event.target.value" />
					</CCol>
					<CDataTable hover striped :items="items" :fields="fields" :noItemsView="{ noItems: 'داده‌ای برای نمایش وجود ندارد' }">
						<template #action="data">
                            <td>
                                <template>
                                    <div class="flex-container">
                                        <div v-show="$store.state.perms.can_delete_did_nums"
                                            @click="delete_modal=true;id= data.item.id"
                                                v-c-tooltip.hover="'حذف'">
                                            <CIcon name="cilTrash" size="lg"/>
                                        </div>
                                    </div>
                                </template>
                            </td>
                        </template>
          		</CDataTable>
				<br>
				<div> 
					<CPagination
					:activePage.sync="page"
					:pages="page_count"
					align="center"
					:doubleArrows="true"
					/>
				</div>
			</CCardBody>
		</CCard>
		</CCol>
		<CModal
			title="دقت کنید"
			size="sm"
			color="danger"
			:show.sync="delete_modal"
			>
			<p>آیا برای حذف شناسه {{id}} اطمینان دارید؟</p>
			<template #footer>
				<CButton @click="delete_modal=false" color="secondary">خیر</CButton>
				<CButton @click="delete_row" color="danger">بله</CButton>
			</template>
		</CModal>
		<CModal
            title="انتخاب شماره"
            size="sm"
            color="info"
            :show.sync="modal"
            >
            <CRow>
                <CCol sm="12">
                    <CInput v-model="number_like" @keyup.enter="get_numbers()" dir="ltr" label="جستجو در شماره‌ها"/>
                    <small>راهنما: برای جستجو در شماره‌ها چند رقم از شماره مورد نظر را وارد کرده و سپس دکمه Enter را فشار دهید. پس از نمایش پیغام پایان جستجو، شماره مورد نظر را از زیر انتخاب کنید.</small>
                </CCol>
                <CCol sm="12">
                    <br/>
                    <label>انتخاب شماره</label>
                    <model-select :options="numbers" v-model="from_selected" placeholder="انتخاب کنید">
                    </model-select>
                    <small class="form-text text-muted w-100">{{form.number.inv}}</small>
                </CCol>
            </CRow>
            <template #footer>
                <CButton @click="form.number.val=from_selected;modal=false;" color="primary">تایید</CButton>
                <CButton @click="modal=false" color="secondary">بستن</CButton>
            </template>
        </CModal>
  </CRow>
</template>

<script>
import { ModelSelect } from 'vue-search-select'
import validator from '../mixins'
export default {
    mixins: { validator },
    components: { ModelSelect },
	data() {
		return {
			row_count: '',
			items: [],
			fields: [
				{ key: 'id', label: 'شناسه' },
                { key: 'number', label: 'شماره' },
                { key: 'real_number', label: 'شماره اصلی' },
                { key: 'action', label: 'عملیات' },
			],
			collapse: false,
			form: {
				number: {val: '', inv: '', v: {max: 64}},
				real_number: {val: '', inv: '', v: {max: 64}},
			},
			disable: false,
			page: 1,
			page_count: 0,
			offset: 0,
			limit: 10,
			delete_modal: false,
            id: 0,
            modal: false,
            number_like: '',
            numbers: [],
            from_selected: '',
		}
	},
	watch: {
        page: {
            handler(){
                this.get();
                window.scrollTo({ top: 0, behavior: 'smooth' });
            }
        },
        limit: {
            handler() {
                this.page = 1;
                this.get();
            }
        }
    },
	mounted() {
		this.get();
	},
	methods: {
        get_numbers() {
            this.axios.get('user_nums/'
                + '?number_like=' + this.number_like)
                .then(res => {
                    res.data.map(val => {
                        this.numbers.push({ value: `${val.number}`, text: `${val.number}`});
                    });
                    this.$notify({
                        group: 'foo',
                        type: 'success',
                        text: 'جستجوی شماره‌ها با موفقیت انجام شد.'
                    });
                })
        },
		get() {
			if(this.disable == false){
				let filter = '';
				for (const key in this.form) {
					if(this.form[key].val != ''){
						filter += `&${key}=` + this.form[key].val;
					}
				}
				this.axios.get('user_nums_did/'
					+ '?count=1'
					+ filter)
					.then(res => {
						this.row_count = String(res.data.count).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                        if(res.data.count > this.limit){
                            this.page_count = Math.ceil(res.data.count / this.limit);
                        } else {
                            this.page_count = 1;
                        }
						this.offset = 0;
						if(this.page != 1){
							this.offset = (this.page * this.limit) - this.limit;
						}
					})
				.finally(() => {
					this.axios.get('user_nums_did/'
						+ '?limit=' + this.limit
						+ '&offset=' + this.offset
						+ filter)
						.then(res => {
							this.items = res.data;
						})
				})
			}
		},
		delete_row() {
			this.axios.delete('user_nums_did/'
			+ this.id)
			.then(() => {
				this.$notify({
					group: 'foo',
					type: 'success',
					text: 'حذف با موفقیت انجام شد.'
				});
				this.delete_modal = false;
				this.get();
			})
			.catch(() => {
				this.$notify({
					group: 'foo',
					type: 'error',
					text: 'خطا! لطفا مجددا تلاش کنید.'
				});
				this.delete_modal = false;
			})
		},
		remove_filter() {
            for (const key in this.form) {
                this.form[key].val = '';
                this.form[key].inv = '';
            }
            this.disable = false;
            this.filter = false;
            this.page = 1;
            this.get();
        },
		redirect_to(route) {
			this.$router.push(route);
		}
	},
	beforeCreate(){
		if(this.$store.state.perms.can_view_did_nums_page == false
			&& this.$store.state.verif == false){
			this.$router.push('/403')
		}
	},
}
</script>